import axios from "axios";

const api = axios.create({
  // baseURL: "http://localhost:8000/api/v1",
  baseURL: "https://ai.digione.com.au/api/v1",
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach JWT token automatically to protected requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Handling unauthorized globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("Unauthorized – token may be expired or invalid");
      localStorage.removeItem("access_token");
      // window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default api;
